"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Component = function () { return (react_1.default.createElement("svg", { width: "20", height: "25", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.229 20H.776c-.753 0-1.002-.525-.552-1.166 0 0 3.293-4.682 3.293-7.561v-.727C3.517 6.93 5.972 4 9 4c3.027 0 5.482 2.93 5.482 6.546v.728c0 2.879 3.293 7.56 3.293 7.56.45.64.204 1.164-.546 1.166zM12 22a3 3 0 11-6 0h6z", fill: "#BEBCB9" }),
    react_1.default.createElement("path", { d: "M14 11a5 5 0 100-10 5 5 0 000 10z", fill: "#F1500D", stroke: "#fff", "stroke-width": "2" }))); };
exports.default = Component;
//# sourceMappingURL=Bell.js.map